/**
 * `?tab=` of the Analytics page (ANLT-01, AD-038): Resumo · Vendas · Push ·
 * Usuários · Pedidos, one tab at a time; Resumo (`overview`) is the absence
 * of the param.
 */

export const ANALYTICS_TABS = [
  'overview',
  'sales',
  'campaigns',
  'users',
  'orders',
] as const;
export type AnalyticsTab = (typeof ANALYTICS_TABS)[number];

function isAnalyticsTab(raw: string): raw is AnalyticsTab {
  return (ANALYTICS_TABS as readonly string[]).includes(raw);
}

/** Unknown, empty or missing → `overview` (Resumo). */
export function parseAnalyticsTab(
  raw: string | null | undefined
): AnalyticsTab {
  return raw && isAnalyticsTab(raw) ? raw : 'overview';
}
